import React, { ReactElement, useEffect, useState } from "react";
import { useAppDispatch } from "redux/hooks";
import { Translate } from "react-redux-i18n";
import { Button, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import FontAwesomeIcon from "../FontAwesomeIcon";
import { PasswordData, requestChangePassword } from "redux/auth/authSlice";
import styles from "./styles.module.scss"

interface VisbilityProps {
  [key: string]: boolean;
  old: boolean,
  new: boolean,
  cNew: boolean
}

export default function ChangePassword(): ReactElement {
  const dispatch = useAppDispatch()
  const [passwordMatch, setPasswordMatch] = useState<boolean>(true);
  const [data, setData] = useState<PasswordData>({
    o_password: "",
    password: "",
    c_password: ""
  })

  const [passwordVisibility, setPasswordVisibility] = useState<VisbilityProps>({
    old: false,
    new: false,
    cNew: false
  })

  const handlePasswordVisibilty = (name: string) => {
    setPasswordVisibility({ ...passwordVisibility, [name]: !passwordVisibility[name] })
  }

  const handleChange = (name: string, value: string) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    if (!passwordMatch) {
      return
    } else {
      dispatch(requestChangePassword(data))
    }
  }

  useEffect(() => {
    if (data.password === data.c_password) {
      setPasswordMatch(true)
    } else {
      setPasswordMatch(false)
    }
  }, [data])

  return (
    <form onSubmit={(e) => handleSubmit(e)} className={styles.changePasswordContainer}>
      <TextField
        value={data.o_password}
        variant="outlined"
        required
        label={<Translate value="dialog.oldPassword" />}
        type={passwordVisibility.old ? "text" : "password"}
        InputProps={{
          className: styles.input,
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton
                onClick={() => handlePasswordVisibilty("old")}
                size='small'
                className={styles.icon}
              >
                {passwordVisibility.old ?
                  <FontAwesomeIcon type="fas" name="eye-slash" />
                  :
                  <FontAwesomeIcon type="fas" name="eye" />
                }
              </IconButton>
            </InputAdornment>
          )
        }}
        InputLabelProps={{ className: styles.inputLabel }}
        name="o_password"
        onChange={(e) =>
          handleChange(e.target.name, e.target.value)
        }
        className={styles.inputContainer}
      />
      <TextField
        value={data.password}
        required
        variant="outlined"
        label={<Translate value="dialog.newPassword" />}
        type={passwordVisibility.new ? "text" : "password"}
        InputProps={{
          className: styles.input,
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton
                onClick={() => handlePasswordVisibilty("new")}
                size='small'
                className={styles.icon}
              >
                {passwordVisibility.new ?
                  <FontAwesomeIcon type="fas" name="eye-slash" />
                  :
                  <FontAwesomeIcon type="fas" name="eye" />
                }
              </IconButton>
            </InputAdornment>
          )
        }}
        InputLabelProps={{ className: styles.inputLabel }}
        name="password"
        onChange={(e) => handleChange(e.target.name, e.target.value)}
        className={styles.inputContainer}
      />
      <TextField
        value={data.c_password}
        required
        variant="outlined"
        label={<Translate value="dialog.confirmPassword" />}
        type={passwordVisibility.cNew ? "text" : "password"}
        InputProps={{
          className: styles.input,
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton
                onClick={() => handlePasswordVisibilty("cNew")}
                size='small'
                className={styles.icon}
              >
                {passwordVisibility.cNew ?
                  <FontAwesomeIcon type="fas" name="eye-slash" />
                  :
                  <FontAwesomeIcon type="fas" name="eye" />
                }
              </IconButton>
            </InputAdornment>
          )
        }}
        InputLabelProps={{ className: styles.inputLabel }}
        name="c_password"
        onChange={(e) => handleChange(e.target.name, e.target.value)}
        className={styles.inputContainer}
      />
      {!passwordMatch && <Typography className={styles.label}><Translate value="userInformation.mismatch" /></Typography>}
      <Button
        // onClick={handleSubmit}
        type="submit"
        variant="contained"
        className={styles.submitButton}>
        <Translate value="dialog.changePassword" />
      </Button>
    </form>
  )
}